/** @format */
import React, {useEffect} from 'react';

// styles
import './password_validator.sass';

export const validatePassword = input => {
    //Has at least one upprcase letter
    const hasUpperCase = /(?=.*?[A-Z])/.test(input);

    //Has at least once digit
    const hasDigit = /(?=.*?[0-9])/.test(input);

    // Has at least one special character
    const hasSpecialChar = /(?=.*?[#?!@$%^&*-])/.test(input);

    // is at least 8 digits long
    const isAtLeast8Long = /.{8,}$/.test(input);

    // passes validation
    let passesValidation;
    if (hasUpperCase && hasDigit && hasSpecialChar && isAtLeast8Long) passesValidation = true;
    else passesValidation = false;

    return {
        hasUpperCase,
        hasDigit,
        hasSpecialChar,
        isAtLeast8Long,
        passesValidation
    };
};

export const PasswordValidator = ({input, handleIsValidPassword}) => {
    const {hasUpperCase, hasDigit, hasSpecialChar, isAtLeast8Long} = validatePassword(input);

    useEffect(() => {
        if (handleIsValidPassword) {
            if (hasUpperCase && hasDigit && hasSpecialChar && isAtLeast8Long)
                handleIsValidPassword(true);
            else handleIsValidPassword(false);
        }
    }, [input]);

    return (
        <div className="password-validator-container">
            <h6 className="font-body-bold-md">Password Requirements</h6>
            <h6
                className={`validation-spec font-body-bold-sm ${
                    hasUpperCase ? 'color-alert-positive' : 'color-alert-negative'
                }`}>
                {hasUpperCase ? <>&#x2713;</> : <>&#10005;</>} Must contain an uppercase letter
            </h6>
            <h6
                className={`validation-spec font-body-bold-sm ${
                    hasDigit ? 'color-alert-positive' : 'color-alert-negative'
                }`}>
                {hasDigit ? <>&#x2713;</> : <>&#10005;</>} Must contain a number
            </h6>
            <h6
                className={`validation-spec font-body-bold-sm  ${
                    hasSpecialChar ? 'color-alert-positive' : 'color-alert-negative'
                }`}>
                {hasSpecialChar ? <>&#x2713;</> : <>&#10005;</>} Must contain a symbol (!,@,#, etc)
            </h6>
            <h6
                className={`validation-spec font-body-bold-sm ${
                    isAtLeast8Long ? 'color-alert-positive' : 'color-alert-negative'
                }`}>
                {isAtLeast8Long ? <>&#x2713;</> : <>&#10005;</>} Must be at least 8 characters
            </h6>
        </div>
    );
};
